import { Divider, Grid } from "@mui/material";
import ThemeContext from "components/app/Context";
import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";

import Checkbox from "components/common/Checkbox";
import BasicTable from "components/common/Table";
import Typography from "components/common/Typography";
import { updateBookmarkedInncodesAsync } from "components/features/dashboard/Dashboard.slice";
import { useTranslate } from "hooks/useTranslate";
import { useContext, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { messages } from "utils/CommonConstants";
import { getBrandCodesForAboveProperties, getHltInncodes } from "utils/CommonFunctions";
import { clearFilter, fetchAbovePropertiesForDialog, setSearchText } from "../../AboveProperty.slice";
import FilterButtons from "../../FilterButtons";
import { headers } from "./TableHeader";

function PropertiesBookmark(props: any) {
  const dispatch = useAppDispatch();
  const translate = useTranslate();
  const { isMobileScreen } = useContext(ThemeContext);
  const [checkedList, setCheckedList] = useState<any>([]);
  const { openBookmarkPropertiesDialog, handleCloseDialog } = props;
  const inncodeOptions = getHltInncodes();
  const [bookmarkedInncode, setBookmarkedInncode] = useState<any>([]);
  const { bookmarkedProperties, filters, allProperties, abovePropertiesDialog }: any = useAppSelector(
    (state) => state.aboveProperty
  );
  const { brandCodes, engagements, inncode, searchText } = filters.dialogFilters.bookmarkProperty;

  useEffect(() => {
    if (openBookmarkPropertiesDialog) dispatch(fetchAbovePropertiesForDialog({}));
  }, [openBookmarkPropertiesDialog]);

  useEffect(() => {
    dispatch(
      fetchAbovePropertiesForDialog({
        searchText,
        brandCodes: getBrandCodesForAboveProperties(brandCodes, allProperties),
        engagements,
        filteredInnCodes: inncode
      })
    );
  }, [brandCodes, engagements, inncode, searchText]);

  useEffect(() => {
    setBookmarkedInncode(bookmarkedProperties?.map((item: any) => item?.innCode));
  }, [bookmarkedProperties]);

  const handleChange = (element: any, event: React.ChangeEvent<HTMLInputElement>) => {
    let arr = [...checkedList];
    if (event.target.checked) {
      arr.push(element);
    } else {
      arr = arr.filter((el: any) => el?.innCode !== element?.innCode);
    }
    setCheckedList(arr);
  };

  const handleAssignPlans = async () => {
    await dispatch(
      updateBookmarkedInncodesAsync({
        bookmarks: [
          ...bookmarkedProperties,
          ...checkedList.map((item: any) => {
            return { innCode: item ? item.innCode : undefined };
          })
        ]
      })
    );
    setCheckedList([]);
    handleCloseDialog();
  };

  return (
    <>
      {openBookmarkPropertiesDialog && (
        <DialogFormation
          title={translate("dashboard.bookmark.hotels")}
          openDialog={openBookmarkPropertiesDialog}
          handleClose={() => {
            setCheckedList([]);
            handleCloseDialog();
            dispatch(clearFilter({ parentView: "dialogFilters", filterType: "bookmarkProperty" }));
            dispatch(
              setSearchText({
                inputText: "",
                searchType: "bookmarkProperty",
                filterName: "searchText",
                parentView: "dialogFilters"
              })
            );
          }}
          actionConfig={
            <div className="modal-config-wrapper">
              <Button
                sx={isMobileScreen ? { width: "100%" } : {}}
                disabled={!checkedList.length}
                variant="primary"
                label={checkedList?.length > 0 ? `Save (${checkedList?.length})` : `Save`}
                onClick={handleAssignPlans}
              />
            </div>
          }
        >
          <FilterButtons
            isBrandsVisible
            isSearchBarVisible
            isEngagementVisible
            isInncodeVisible
            parentView="dialogFilters"
            optionsList={{ inncode: inncodeOptions }}
            filterType="bookmarkProperty"
            searchPredefinedValue={searchText}
            searchBarPlaceHolder="Search by property"
          />
          <Divider />
          <BasicTable
            scroll
            noDataMessage={messages.noAbovePropertiesData}
            data={{
              headers,
              rows: abovePropertiesDialog
                ?.filter((item: any) => !bookmarkedInncode?.includes(item?.innCode))
                .map((r: any) => {
                  return {
                    data: [
                      {
                        content: (
                          <Grid display="flex" flexDirection={"row"} width="180px">
                            <Checkbox
                              onChange={(event: any) => handleChange(r, event)}
                              checked={
                                (checkedList.filter((item: any) => item && item.innCode === r?.innCode) || []).length
                              }
                            />

                            <Typography sx={{ fontWeight: "700", marginTop: "8px" }} showBold variant={"body2"}>
                              {r?.propertyName || ""}
                            </Typography>
                          </Grid>
                        )
                      },
                      { content: r?.innCode },
                      { content: r?.brandName || "" },
                      { content: r?.leaderPlans },
                      { content: r?.teamPlans },
                      { content: r?.engagement }
                    ]
                  };
                })
            }}
          />
        </DialogFormation>
      )}
    </>
  );
}
export default PropertiesBookmark;
